import http from '@/services/http.service'

/**
 * 'Permissions' Store
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

export default {
  namespaced: true,
  state: {
    me: {},
    permissions: []
  },
  getters: {
    me: state => {
      return state.me
    },
    permissions: state => {
      return state.permissions
    },
    can: (state) => (permission) => {
      return !!state.permissions.find(x => {
        return x === permission
      })
    }
  },
  mutations: {
    me (state, payload) {
      state.me = payload
    },
    permissions (state, payload) {
      state.permissions = payload
    }
  },
  actions: {
    me ({commit}, payload) {
      return http.get('auth/user').then(({data}) => {
        return http.get('users/' + data.id).then(({data}) => {
          commit('me', data)
        })
      })
    },
    permissions ({commit}, payload) {
      return http.get('auth/permissions').then(({data}) => {
        commit('permissions', data)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/profile/index.js